import React from "react";
import EnvironmentEditor from "../EnvironmentEditor/Main.js";
import RegionEditor from "../RegionEditor/Main.js";
import BoringDBEditor from "../BoringDBEditor/Main.js";
import { connect } from "react-redux";
import { openSwAction, openDBEditorAction } from "../../redux/ui/actions";
import { changeSwModeAction } from "../../redux/app/actions";
import Sw from "../common/Sw";

const mapStateToProps = (state) => {
    return {
        swMode: state.appReducer.swMode,
    };
};

class Main extends React.Component {
    /*★ここから公開版で削除*/
    constructor(props) {
        super(props);
    }

    goBack = () => {
        this.props.dispatch(openSwAction(null));
        this.props.dispatch(changeSwModeAction(0));
    };

    render() {
        return (
            <Sw title="データベースエディタ">
                <div>
                    <fieldset className="Unit">
                        <div className="l-row">
                            <legend>環境データ</legend>
                            <EnvironmentEditor />
                        </div>
                    </fieldset>

                    <fieldset className="Unit">
                        <legend>地域データ</legend>
                        <div className="l-row">
                            <RegionEditor />
                        </div>
                    </fieldset>

                    <fieldset className="Unit">
                        <legend>ボーリングファイル</legend>
                        <div className="l-row">
                            <BoringDBEditor />
                        </div>
                    </fieldset>

                    <div className="l-right l-mtM">
                        <button className="cBtn l-mlS" onClick={this.goBack}>
                            閉じる
                        </button>
                    </div>
                </div>
            </Sw>
        );
    }
}

export default connect(mapStateToProps)(Main);
